import React, { useEffect, useState } from 'react';
import api from '@/api';
import toast from 'react-hot-toast';

const CoverageInfo = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get('/dashboard/stats');
        const offres = res.data.offres_count;
        const taux = res.data.matches_realises_count;
        const couvertes = Math.round((taux / 100) * offres);
        setData({ offres, taux, couvertes });
      } catch (error) {
        console.error('Erreur lors du chargement des statistiques', error);
        toast.error("Impossible de charger les statistiques de couverture.");
      }
    };
    fetchData();
  }, []);

  if (!data) {
    return <p className="text-pro-dark-text-secondary">Chargement...</p>;
  }

  return (
    <div className="animate-fade-in space-y-6">
      <div>
        <h1 className="text-4xl font-bold text-pro-dark-text-primary">Taux de couverture</h1>
        <p className="text-lg text-pro-dark-text-secondary">
          Ce pourcentage indique la part des appels d'offres disposant d'au moins un candidat correspondant.
        </p>
      </div>

      <div className="bg-pro-dark-surface p-6 rounded-2xl shadow-lg space-y-2">
        <p><strong>Total d'offres:</strong> {data.offres}</p>
        <p><strong>Offres avec candidat compatible:</strong> {data.couvertes}</p>
        <p><strong>Taux de couverture:</strong> {data.taux}%</p>
      </div>

      <p className="text-sm text-pro-dark-text-secondary">
        Calcul: ({data.couvertes} / {data.offres}) × 100 = {data.taux}%
      </p>
    </div>
  );
};

export default CoverageInfo;
